module.exports = __webpack_public_path__ + "static/media/helper_enitity_name.68edfc98.jpg";